import { API_URL } from "../config";

/** Project summary as returned by GET /api/project/list and /create.
 *  Mirrors api/project_routes.py::_project_summary / the DB list shape. */
export interface ProjectSummary {
  project_id: string;
  name: string;
  dot: string;
  crs_epsg: number;
  created: string;
  total_assets: number;
  has_corridor: boolean;
  has_alignment: boolean;
  /** Per-asset-type counts. Empty from /list (DB path); populated by GET /<id>. */
  asset_counts: Record<string, number>;
}

export async function listProjects(): Promise<ProjectSummary[]> {
  const res = await fetch(`${API_URL}/api/project/list`);
  if (!res.ok) throw new Error(`Project list failed (HTTP ${res.status})`);
  const data = await res.json();
  const projects: ProjectSummary[] = data.projects ?? [];
  // Newest first.
  return projects.sort((a, b) => (a.created < b.created ? 1 : -1));
}

export async function createProject(
  name: string,
  dot = "oab_default",
  crsEpsg = 2240
): Promise<ProjectSummary> {
  const res = await fetch(`${API_URL}/api/project/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, dot, crs_epsg: crsEpsg }),
  });
  if (!res.ok) throw new Error(`Create project failed (HTTP ${res.status})`);
  return res.json();
}

/** Prettify a DOT code for display (oab_default -> Default). */
export function dotLabel(dot: string): string {
  if (!dot || dot === "oab_default") return "Default";
  return dot.toUpperCase();
}
